import React from 'react';
import CustomTable from './CustomTable';

const InventoryMovementsTable = ({ movements }) => {
    const columns = [
        { header: 'Fecha', accessor: 'movement_date', render: (date) => new Date(date).toLocaleDateString() },
        { header: 'Producto', accessor: 'product_name' },
        { header: 'UM', accessor: 'um' },
        { header: 'Factor CJ', accessor: 'factor_cj' },
        { header: 'Tipo Producto', accessor: 'tipo_producto' },
        { 
            header: 'Tipo Movimiento', 
            accessor: 'movement_type',
            render: (type) => (
                <span style={{ 
                    color: type === 'entrada' ? '#27ae60' : '#e74c3c', 
                    fontWeight: 'bold' 
                }}>
                    {type === 'entrada' ? '📈 Entrada' : '📉 Salida'}
                </span>
            )
        },
        { header: 'Cantidad', accessor: 'quantity' },
        { header: 'Cliente', accessor: 'customer_name' },
        { header: 'Pedido', accessor: 'order_id' },
        { header: 'Stock Anterior', accessor: 'previous_stock' },
        { header: 'Stock Nuevo', accessor: 'new_stock' },
        { header: 'Motivo', accessor: 'reason' },
    ];

    return <CustomTable columns={columns} data={movements} />;
};

export default InventoryMovementsTable;